import React from 'react';
import { Card, Statistic } from 'antd';

/**
 * StatCard — 统计卡片（Card + Statistic 封装）
 *
 * @param {string} title     统计项标题
 * @param {any}    value     统计值（传给 Statistic）
 * @param {string} suffix    值后缀（如 "个" / "%"）
 * @param {node}   icon      前缀图标（React 节点）
 * @param {string} color     强调色（CSS 变量名或色值）
 */
const StatCard = ({
  title,
  value,
  suffix,
  icon,
  color = '#F4DFA2',
}) => {
  return (
    <Card
      bordered={false}
      style={{
        background: 'var(--glass-sm)',
        border: '1px solid var(--border-default)',
        borderRadius: 'var(--radius-md)',
        transition: 'border-color 200ms var(--ease), transform 200ms var(--ease)',
      }}
      styles={{
        body: { padding: '20px 24px' },
      }}
      hoverable
    >
      <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between' }}>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{
            fontSize: 13,
            color: 'var(--text-secondary)',
            marginBottom: 8,
            fontWeight: 400,
            fontFamily: 'var(--font-sans)',
          }}>
            {title}
          </div>
          <Statistic
            value={value}
            suffix={suffix}
            valueStyle={{
              color: color,
              fontSize: 26,
              fontWeight: 600,
              fontFamily: 'var(--font-sans)',
              letterSpacing: '-0.02em',
            }}
          />
        </div>
        {icon && (
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 44,
            height: 44,
            borderRadius: 12,
            background: 'var(--glass-md)',
            color: color,
            fontSize: 20,
            flexShrink: 0,
            marginLeft: 16,
          }}>
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
};

export default StatCard;
